const translations = {
  all: "всі",
  "armchairs and poufs": "крісла та пуфи",
  "rugs and blankets": "килими та пледи",
  pillows: "подушки",
  // "Kids Collection": "Дитяча колекція",
  // "Fashion": "Одяг".
  // "Decor": "Декор",
};

function normalizeText(text) {
  return text.replace(/\s+/g, " ").trim().toLowerCase();
}

const __locale = document.querySelector("html").getAttribute("lang");

if (__locale == "uk") {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === "childList") {
        const filterButtons = document.querySelectorAll(".filter-select__item, .filter-select__current");
        filterButtons.forEach((button) => {
          const text = normalizeText(button.innerText);
          const translatedText = translations[text];
          if (translatedText) {
            button.innerText = translatedText;
          }
        });
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
}

function translateCatalog() {
  const translations__ = {
    all: "всі",
    "armchairs and poufs": "крісла та пуфи",
    "rugs and blankets": "килими та пледи",
    pillows: "подушки",
    // "Kids Collection": "Дитяча колекція",
    // "Fashion": "Одяг".
    // "Decor": "Декор",
  };



  if (__locale == "uk") {
    const filterButtons = document.querySelectorAll(".filter-select__item");
    filterButtons.forEach((button) => {
      const text = button.getAttribute("data-value");
      const translatedText_ = translations__[text];
      if (translatedText_) {
        button.innerText = translatedText_;
      }
    });
  }
}


// ========== Catalog Section ==========
const queryString = window.location.search;
const searchParams = new URLSearchParams(queryString);
const searchFilter = searchParams.get("filter.p.m.custom.filter");

const catalogSection = document.querySelector(".catalog");
let filterButtons = catalogSection.querySelectorAll(".filter-select__item");

const handlerTabToggle = (i) => {
  filterButtons.forEach((item) => item.classList.remove("_active"));
  filterButtons[i] && filterButtons[i].classList.add("_active");
  if (filterButtons[i]) {
    let select = filterButtons[i].closest(".filter-select");
    let text = filterButtons[i].innerText;
    let current = select.querySelector(".filter-select__current");
    current.innerText = text;
  }
};
filterButtons.forEach((button, i) => {
  button.getAttribute("data-value") == searchFilter && handlerTabToggle(i);
  button.addEventListener("click", () => handlerTabToggle(i));
});

let select = function () {
  let selectWrapper = document.querySelectorAll(".filter-select");
  let selectHeader = document.querySelectorAll(".filter-select__header");
  let selectBody = document.querySelector(".filter-select__body");
  let selectItems = selectBody.querySelectorAll(".filter-select__item");
  setSelectBodyHeight();

  selectHeader.forEach((item) => {
    item.addEventListener("click", selectToggle);
  });

  selectItems.forEach((item) => {
    item.addEventListener("click", selectChoose);
  });

  function selectToggle() {
    this.parentElement.classList.toggle("is-active");
    setSelectBodyHeight();
    translateCatalog();
  }

  function setSelectBodyHeight() {
    let selectBodyHeight = selectBody.scrollHeight;
    document.documentElement.style.setProperty("--height-filter-select-body", `${selectBodyHeight}px`);
  }

  async function selectChoose() {
    let text = this.innerText,
      select = this.closest(".filter-select"),
      currentText = select.querySelector(".filter-select__current"),
      url = this.getAttribute("data-filter"),
      value = this.getAttribute("data-value");
    currentText.innerText = text;
    select.classList.remove("is-active");
    await sortCollection(url, value);
    await paginate();
  }

  document.addEventListener("mousedown", (e) => {
    selectWrapper.forEach((select) => {
      if (e.target.closest(".filter-select") != select) {
        select.classList.remove("is-active");
      }
    });
  });
};

async function sortCollection(url, value) {
  const locale = document.querySelector("html").getAttribute("lang");
  const finalUrl =
    url === "all" && value === "all"
      ? `${locale == "uk" ? "/uk" : ""}/collections/all`
      : `${locale == "uk" ? "/uk" : ""}/collections/all?${url}=${value}`;

  try {
    const response = await fetch(finalUrl);
    const data = await response.text();
    const parsedHTML = new DOMParser().parseFromString(data, "text/html");
    document.querySelector("#ProductGridContainer").innerHTML = parsedHTML.querySelector("#ProductGridContainer").innerHTML;
    history.replaceState(null, null, finalUrl);
  } catch (error) {
    console.error("Error:", error);
  } finally {
    this.loading = false;
    $("html").getNiceScroll().onResize();
  }
}

async function paginate() {
  const productGridContainer = document.getElementById("ProductGridContainer");
  const loadMoreBtn = document.querySelector(".catalog__more-btn");
  let dataCount = document.querySelector(".data-count");
  const productCount = parseInt(dataCount.dataset.count);
  let currentPage = 1;
  let displayedCards;
  function setInitialCards() {
    const width = window.innerWidth;
    const cardsPerPage = width < 768 ? 8 : 9;
    displayedCards = cardsPerPage;
    updateCards(cardsPerPage, true);
  }

  async function handleLoadMore() {
    const width = window.innerWidth;
    const cardsPerPage = width < 768 ? 4 : 6;
    displayedCards += cardsPerPage;
    updateCards(displayedCards);
    width > 768 &&  $("html").getNiceScroll().onResize();
  }

  function updateCards(cardsToShow, isInitial = false) {
    const products = Array.from(productGridContainer.querySelectorAll(".grid__item"));

    products.forEach((product, index) => {
      if (index < cardsToShow) {
        product.style.display = "block";
      } else if (isInitial) {
        product.style.display = "none";
      }
    });

    if (cardsToShow >= productCount) {
      loadMoreBtn.style.display = "none";
    } else {
      currentPage += 1;
    }
  }

  function resetPagination() {
    currentPage = 1;
    setInitialCards();
  }

  setInitialCards();
  loadMoreBtn.addEventListener("click", handleLoadMore);
//  window.addEventListener("resize", resetPagination);

  if (productCount <= 9) {
    loadMoreBtn.style.display = "none";
  }
}

paginate();
select();

window.addEventListener("resize", () => {
  const openSelect = document.querySelector(".filter-select.is-active");
  openSelect && openSelect.classList.remove("is-active");
});
